<template>


  <div>
    <b-media tag="li">
      <template v-slot:aside>
        <span class="bg-info pt-3" id="media-wrapper">
          <font-awesome-icon class="text-white align-middle" icon="user" size="2x"></font-awesome-icon>
        </span>
      </template>
      <h5 class="mt-0 mb-3 text-left">
        <!-- <router-link class="text-blue" :to="{ name: 'groupView', params: { id: group.id }}"  title="View the admission rules and all the members" v-b-tooltip.hover.right> -->
          {{ getTitle }}
          <!-- </router-link> -->
      </h5>
      <p class="mb-0 text-left">
        <b-row>
          <b-col cols="6" lg="12" md="12" sm="12" xs="12">              
          <!--  <span class="mr-lg-2" title="Creation date" v-b-tooltip.hover.bottom>
              <font-awesome-icon icon="calendar-alt"/> {{ group.created | utcLocalDate }}
            </span>
            <span v-if="group.creator" style="margin-right:10px"  title="Owner of the group" v-b-tooltip.hover.bottom>
              <font-awesome-icon icon="user"></font-awesome-icon> {{ group.creator.name }}
            </span>
            <span class="mr-lg-2" title="Edit the Group" v-b-tooltip.hover.bottom>
             <font-awesome-icon icon="edit"/>
          Edit
          </span>

 <span class="mr-lg-2" title="Delete this date" v-b-tooltip.hover.bottom>        
            <font-awesome-icon icon="trash-alt"/>
          Delete
          </span> -->

                 <span class="float-left align-top" >
              <b-button 
              class="btn bg-orange btn-sm"
               @click="Expell(group.id)"
               v-if="isCreatedbyOwner"
               >
                Expell <font-awesome-icon icon="sign-out-alt" size="lg"></font-awesome-icon>
              </b-button>
            </span>
          </b-col>
        </b-row>
      </p>
    </b-media>
    <hr>
  </div>
</template>

<script>
import axios from 'axios'
import {eventBus} from '../../main'

export default {
  name: 'GroupMedia',
  props: {
    'group': Object
  },
  computed: {
    getTitle () {
      let title = this.group.name
      if (title) {
        return title
      }
      return '<Untitled>'
    },
    isCreatedbyOwner: function () {
      if (this.group.creator === this.$store.state.user.login) {
        return true;
      } else {
        return false;
      }
    },


  },
  methods: {

    

    Expell (groupId) {
        console.log()
        let a = groupId
  eventBus.$emit('MemberToBeExpelled', a)
  console.log(a)
    }
  }
}
</script>

<style scoped>
#media-wrapper {
  width: 64px;
  height: 64px
}
</style>



// WEBPACK FOOTER //
// src/components/groups/MembersMedia.vue